import "./App.css";
import ItemList from "./components/ItemList";

function App() {
  return (
    <div className="item-app">
      <ItemList />
    </div>
  );
}

export default App;
